import * as React from 'react'
import { colors } from '../colors'

export type PropsType = {
  size?: number,
  color?: string
}

const TagIcon = (props: PropsType): React.ReactNode => {
  return (
    <svg
      width={props.size || 16}
      height={props.size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.4173 7.10363L8.60997 14.2961L14.2958 8.60989L7.09753 1.41158H1.52864L1.4173 7.10363ZM8.60996 16.0002C8.42274 16.0002 8.24328 15.9257 8.11093 15.7934L0.206778 7.88921C0.0709045 7.75369 -0.00373791 7.56841 0.000144206 7.37642L0.130724 0.691952C0.138136 0.307447 0.451881 -0.00012207 0.836386 -0.00012207H7.39009C7.57714 -0.00012207 7.75678 0.0743439 7.88912 0.206689L15.7933 8.11084C16.0689 8.38647 16.0689 8.83344 15.7933 9.1089L9.10899 15.7934C8.97664 15.9257 8.79701 16.0002 8.60996 16.0002Z"
        fill={props.color || colors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.59901 4.4997C5.59901 5.03579 5.16439 5.47023 4.62849 5.47023C4.0924 5.47023 3.65796 5.03579 3.65796 4.4997C3.65796 3.96379 4.0924 3.52917 4.62849 3.52917C5.16439 3.52917 5.59901 3.96379 5.59901 4.4997Z"
        fill={props.color || colors.white}
      />
    </svg>
  )
}

export default TagIcon
